// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.idisfIAIQAIlOa90 {
  margin-bottom: 32px;
  padding: 24px;
  background: #fff;
  border: 1px solid #eef0f3;
  border-radius: 8px;
}
.yOFoI2kBO_U5FOCH {
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.u4EH2J52ceYC2oVU {
  margin: 24px 0 8px;
  border-top: 1px solid #f0f0f0;
}
.H4UBTpPtREk2EZ_h {
  padding: 24px;
  color: #999;
  text-align: center;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
.f7JJ_gnm3yUA6rq8 {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
  padding-bottom: 32px;
}
.yepEWB1dKt4Ea75K {
  margin-bottom: 16px;
}
.Qihw7CHxa1EvIPAu {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.ZR2mSoEFMBAnpNiv,
.sHcZwDaa7yIer5VP {
  padding: 6px 16px;
  font-size: 13px;
  line-height: 1.5;
  border: 1px solid;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
  font-family: inherit;
}
.ZR2mSoEFMBAnpNiv {
  color: #4b5563;
  background: #fff;
  border-color: #e5e7eb;
  font-weight: 400;
}
.ZR2mSoEFMBAnpNiv:hover {
  border-color: #93c5fd;
  color: #4b5563;
  background: #fff;
}
.sHcZwDaa7yIer5VP {
  color: #2563eb;
  background: #eff6ff;
  border-color: #3b82f6;
  font-weight: 500;
}
.sHcZwDaa7yIer5VP:hover {
  color: #2563eb;
  background: #eff6ff;
  border-color: #3b82f6;
}
.r3OS4ocywUgl60fQ {
  margin-left: 6px;
  font-size: 12px;
  line-height: 18px;
}
.W5lM5NAhKI1GbRhA {
  display: flex;
  margin-bottom: 16px;
}
.uNexJ5UzBz4cdGtA {
  width: 150px;
  padding-right: 12px;
  text-align: right;
  color: #333;
  line-height: 32px;
  flex-shrink: 0;
}
.KWXooUJKQcAbACpE {
  flex: 1;
  min-width: 0;
}
.dkHgapqjssooT0yJ {
  margin-left: 150px;
  padding-left: 12px;
}
.IMVtth1fGBgR_5w7 {
  margin-right: 4px;
  color: #ff4d4f;
}
.qRxU1zbG8IciBPLI .ant-form-item-control-input-content {
  display: flex;
  align-items: center;
  min-height: 32px;
}
.RPku8vZc1FQfWuuS {
  margin-top: -8px;
}
.ZdDjhcibieQ38TRu {
  margin-top: 0;
  padding: 20px;
  background: #f8fafc;
  border: 1px solid #f3f4f6;
  border-radius: 8px;
}
.RYsjMD3yquQeQ6g6 {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  color: #999;
  font-size: 12px;
  line-height: 1.5;
}
.z6YCr5YSsfXlEVF7 {
  margin-right: 6px;
  color: #69b1ff;
  font-size: 14px;
  flex-shrink: 0;
}
.bZf3g6vKm8oe_x8r {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}
.Sz0BElC3hwDkHilv {
  position: relative;
  padding: 12px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}
.Sz0BElC3hwDkHilv:hover {
  border-color: #91caff;
}
.Sz0BElC3hwDkHilv:hover .N4jC1g19AweKArSv {
  opacity: 1;
}
.dbGfGDh9poaaZ_0i {
  background: #e6f4ff;
  border-color: #1677ff;
  box-shadow: 0 1px 4px rgba(22, 119, 255, 0.12);
}
.dbGfGDh9poaaZ_0i .eCsmza2pGsQ2nd7M {
  color: #1677ff;
}
.m2ro4AfTZsUmhD9K {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}
.eCsmza2pGsQ2nd7M {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}
.EqnBHD_WysngfuEp {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}
.DAkmoe58XtEktWN_ {
  flex: 1;
  min-width: 0;
  font-size: 11px;
  color: #999;
  line-height: 1.5;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.JmeVWERrFZ46iVeI {
  color: #1677ff;
}
.MD1dA4Kel4eE_4YB {
  flex-shrink: 0;
  color: #69b1ff;
  font-size: 12px;
  cursor: default;
}
.N4jC1g19AweKArSv {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: #f5f5f5;
  color: #666;
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s, border-color 0.2s, color 0.2s, background 0.2s;
}
.N4jC1g19AweKArSv .anticon {
  font-size: 11px;
}
.N4jC1g19AweKArSv:hover {
  border-color: #91caff;
  background: #e6f4ff;
  color: #1677ff;
}
.iTDEI2rktfgdQM2c {
  opacity: 1;
  background: #fff;
  border-color: #91caff;
  color: #1677ff;
}
.c5qJZOx4UDkzUHWG {
  margin-top: 12px;
  color: #ff4d4f;
  font-size: 12px;
}
.Pkhb8M_Co8YLZu3g {
  margin-top: 8px;
  color: #666;
  font-size: 13px;
}
.RY3jBUIfows25l5s {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;
  max-height: 360px;
  overflow-y: auto;
}
.WtcrdLcyRAQHlCXU .ant-modal-content {
  padding: 0;
  overflow: hidden;
  border-radius: 8px;
}
.WtcrdLcyRAQHlCXU .ant-modal-header {
  margin-bottom: 0;
  padding: 16px 24px;
  border-bottom: 1px solid #f3f4f6;
}
.WtcrdLcyRAQHlCXU .ant-modal-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
}
.WtcrdLcyRAQHlCXU .ant-modal-body {
  padding: 24px;
}
.WtcrdLcyRAQHlCXU .ant-modal-footer {
  margin-top: 0;
  padding: 16px 24px;
  background: #f9fafb;
  border-top: 1px solid #f3f4f6;
}
.WtcrdLcyRAQHlCXU .ant-modal-close {
  top: 16px;
  inset-inline-end: 20px;
  color: #999;
}
.WtcrdLcyRAQHlCXU .ant-modal-close:hover {
  color: #666;
}
.hPUYRA2AdTI0PgxA {
  display: flex;
  justify-content: flex-end;
}
.M_DM1NGbUk4ZzC9X {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
}
.HZC_1Ei9w8A3i0YA {
  display: flex;
  align-items: center;
  min-width: 0;
  margin: 0;
  font-size: 13px;
  color: #333;
  cursor: pointer;
}
.HZC_1Ei9w8A3i0YA .ant-checkbox-wrapper {
  align-items: center;
  font-size: 13px;
  color: #333;
}
.HZC_1Ei9w8A3i0YA:hover .ant-checkbox-wrapper {
  color: #1677ff;
}
.C8GWlu84gH3DXYIr {
  padding: 0;
  overflow: hidden;
}
.z1eNzk7SNYzcwFfq {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}
.X7oa86RvxA5bAP6W {
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.c81w0JBvJMwLucOJ {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
}
.DjoEQTEhMKg6_8JQ {
  width: 4px;
  height: 16px;
  border-radius: 999px;
  background: #722ed1;
  flex-shrink: 0;
}
.j430bc7vcbMvTcD2 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #333;
}
.WKdP7i0Y5w0j_scK {
  color: #999;
  font-size: 16px;
  cursor: help;
}
.WKdP7i0Y5w0j_scK:hover {
  color: #1677ff;
}
.SFOsdKtW0vow56CL {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  padding: 8px 24px 0;
  overflow-x: auto;
}
.HuwrlCWgyeU0sRqd {
  display: inline-flex;
  align-items: flex-start;
  gap: 6px;
  padding: 10px 20px;
  border: 1px solid transparent;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  background: transparent;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s, background 0.2s, border-color 0.2s;
}
.HuwrlCWgyeU0sRqd:hover {
  color: #333;
}
.sbtExcCLYhAxGiB7 {
  position: relative;
  z-index: 1;
  margin-bottom: -1px;
  border-color: #e5e7eb;
  background: #fff;
  color: #1677ff;
  font-weight: 600;
}
.cpyBDSEowob_Db2I {
  line-height: 20px;
}
.ylmUXV4g_ukEg_RM {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
}
.iL3u70KIbakaVBn9,
.B3P_X16WNO8SyKww {
  display: inline-flex;
  align-items: center;
  padding: 0 6px;
  font-size: 10px;
  line-height: 18px;
  border-radius: 4px;
}
.iL3u70KIbakaVBn9 {
  color: #1677ff;
  background: #e6f4ff;
  border: 1px solid #91caff;
}
.B3P_X16WNO8SyKww {
  color: #999;
  background: #f5f5f5;
}
.zJD7uVXnOuUtLUe8 {
  color: #ff4d4f;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  font-weight: 600;
}
.fsBKYdGuiqUqQ44C {
  color: #ff4d4f;
}
.fsBKYdGuiqUqQ44C:not(.sbtExcCLYhAxGiB7) {
  border-color: #ffccc7;
  background: #fff2f0;
}
.fsBKYdGuiqUqQ44C.sbtExcCLYhAxGiB7 {
  color: #ff4d4f;
  border-color: #ffa39e;
}
.wGTivW_5FXkG6PAe {
  padding: 24px 32px 32px;
}
.wDjEf51HIoQmnJKq {
  margin-bottom: 24px;
  background: #e6f4ff;
  border: none;
}
.wDjEf51HIoQmnJKq .ant-alert-message {
  color: #1677ff;
  font-size: 12px;
}
.Qugjoe4QRsrkx4g3 .ant-form-item-label {
  min-width: 150px;
}
._1CLyf6dMDvaPrS5 {
  display: none;
}
.b79ABVX7K7cPTSY_ .ant-form-item-control-input-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-height: 32px;
}
.qQqWh2TH6Q0kVSXW {
  margin: 0;
  font-size: 11px;
  line-height: 18px;
}
.ezPwQFmBbgs1mSKy {
  color: #999;
  font-size: 11px;
}
@media (max-width: 960px) {
  .bZf3g6vKm8oe_x8r {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .bZf3g6vKm8oe_x8r {
    grid-template-columns: 1fr;
  }
  .W5lM5NAhKI1GbRhA {
    flex-direction: column;
  }
  .uNexJ5UzBz4cdGtA {
    width: auto;
    text-align: left;
    line-height: 1.5;
    margin-bottom: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/intl/Register/index.modules.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AACF;AAEA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAAF;AAGA;EACE,kBAAA;EACA,6BAAA;AADF;AAIA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AAFF;AAKA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AAHF;AAMA;EACE,mBAAA;AAJF;AAOA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AALF;AAQA;;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,oBAAA;AANF;AASA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AAPF;AASE;EACE,qBAAA;EACA,cAAA;EACA,gBAAA;AAPJ;AAWA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AATF;AAWE;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AATJ;AAaA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAXF;AAcA;EACE,aAAA;EACA,mBAAA;AAZF;AAeA;EACE,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AAbF;AAgBA;EACE,OAAA;EACA,YAAA;AAdF;AAiBA;EACE,kBAAA;EACA,kBAAA;AAfF;AAkBA;EACE,iBAAA;EACA,cAAA;AAhBF;AAmBA;EAEI,aAAA;EACA,mBAAA;EACA,gBAAA;AAlBJ;AAsBA;EACE,gBAAA;AApBF;AAuBA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AArBF;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAtBF;AAyBA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAvBF;AA0BA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAxBF;AA2BA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,+DAAA;AAzBF;AA2BE;EACE,qBAAA;AAzBJ;AAwBE;EAII,UAAA;AAzBN;AA8BA;EACE,mBAAA;EACA,qBAAA;EACA,8CAAA;AA5BF;AAyBA;EAMI,cAAA;AA5BJ;AAgCA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AA9BF;AAiCA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AA/BF;AAkCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAhCF;AAmCA;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAjCF;AAoCA;EACE,cAAA;AAlCF;AAqCA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAnCF;AAsCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,wEAAA;AApCF;AAsBA;EAiBI,eAAA;AApCJ;AAuCE;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AArCJ;AAyCA;EACE,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AAvCF;AA0CA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAxCF;AA2CA;EACE,eAAA;EACA,WAAA;EACA,eAAA;AAzCF;AA4CA;EACE,aAAA;EACA,gDAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AA1CF;AA6CA;EAEI,UAAA;EACA,gBAAA;EACA,kBAAA;AA5CJ;AAwCA;EAQI,gBAAA;EACA,kBAAA;EACA,gCAAA;AA7CJ;AAmCA;EAcI,eAAA;EACA,gBAAA;EACA,WAAA;AA9CJ;AA8BA;EAoBI,aAAA;AA/CJ;AA2BA;EAwBI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;AAhDJ;AAqBA;EA+BI,SAAA;EACA,sBAAA;EACA,WAAA;AAjDJ;AAmDI;EACE,WAAA;AAjDN;AAsDA;EACE,aAAA;EACA,yBAAA;AApDF;AAuDA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,WAAA;AArDF;AAwDA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAtDF;AA+CA;EAUI,mBAAA;EACA,eAAA;EACA,WAAA;AAtDJ;AAyDE;EACE,cAAA;AAvDJ;AA2DA;EACE,UAAA;EACA,gBAAA;AAzDF;AA4DA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA1DF;AA6DA;EACE,mBAAA;EACA,gCAAA;AA3DF;AA8DA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;AA5DF;AA+DA;EACE,UAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AA7DF;AAgEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA9DF;AAiEA;EACE,WAAA;EACA,eAAA;EACA,YAAA;AA/DF;AAiEE;EACE,cAAA;AA/DJ;AAmEA;EACE,aAAA;EACA,iBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;AAjEF;AAoEA;EACE,oBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,0DAAA;AAlEF;AAoEE;EACE,WAAA;AAlEJ;AAsEA;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AApEF;AAuEA;EACE,iBAAA;AArEF;AAwEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AAtEF;AAyEA;;EAEE,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAvEF;AA0EA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;AAxEF;AA2EA;EACE,WAAA;EACA,mBAAA;AAzEF;AA4EA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AA1EF;AA6EA;EACE,cAAA;AA3EF;AA6EE;EACE,qBAAA;EACA,mBAAA;AA3EJ;AA8EE;EACE,cAAA;EACA,qBAAA;AA5EJ;AAgFA;EACE,uBAAA;AA9EF;AAiFA;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;AA/EF;AA4EA;EAMI,cAAA;EACA,eAAA;AA/EJ;AAmFA;EAEI,gBAAA;AAlFJ;AAsFA;EACE,aAAA;AApFF;AAuFA;EAEI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAtFJ;AA0FA;EACE,SAAA;EACA,eAAA;EACA,iBAAA;AAxFF;AA2FA;EACE,WAAA;EACA,eAAA;AAzFF;AA4FA;EACE;IACE,gDAAA;EA1FF;AACF;AA6FA;EACE;IACE,0BAAA;EA3FF;EA8FA;IACE,sBAAA;EA5FF;EA+FA;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;EA7FF;AACF","sourcesContent":[".section {\n  margin-bottom: 32px;\n  padding: 24px;\n  background: #fff;\n  border: 1px solid #eef0f3;\n  border-radius: 8px;\n}\n\n.sectionTitle {\n  margin-bottom: 16px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.sectionDivider {\n  margin: 24px 0 8px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.placeholder {\n  padding: 24px;\n  color: #999;\n  text-align: center;\n  background: #fafafa;\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n}\n\n.footerBar {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  margin-top: 24px;\n  padding-bottom: 32px;\n}\n\n.infoAlert {\n  margin-bottom: 16px;\n}\n\n.languageTags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.langTagOption,\n.langTagSelected {\n  padding: 6px 16px;\n  font-size: 13px;\n  line-height: 1.5;\n  border: 1px solid;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  outline: none;\n  font-family: inherit;\n}\n\n.langTagOption {\n  color: #4b5563;\n  background: #fff;\n  border-color: #e5e7eb;\n  font-weight: 400;\n\n  &:hover {\n    border-color: #93c5fd;\n    color: #4b5563;\n    background: #fff;\n  }\n}\n\n.langTagSelected {\n  color: #2563eb;\n  background: #eff6ff;\n  border-color: #3b82f6;\n  font-weight: 500;\n\n  &:hover {\n    color: #2563eb;\n    background: #eff6ff;\n    border-color: #3b82f6;\n  }\n}\n\n.langTag {\n  margin-left: 6px;\n  font-size: 12px;\n  line-height: 18px;\n}\n\n.formItemLike {\n  display: flex;\n  margin-bottom: 16px;\n}\n\n.formItemLabel {\n  width: 150px;\n  padding-right: 12px;\n  text-align: right;\n  color: #333;\n  line-height: 32px;\n  flex-shrink: 0;\n}\n\n.formItemControl {\n  flex: 1;\n  min-width: 0;\n}\n\n.formControlOffset {\n  margin-left: 150px;\n  padding-left: 12px;\n}\n\n.requiredMark {\n  margin-right: 4px;\n  color: #ff4d4f;\n}\n\n.regionModeItem {\n  :global(.ant-form-item-control-input-content) {\n    display: flex;\n    align-items: center;\n    min-height: 32px;\n  }\n}\n\n.regionPanelItem {\n  margin-top: -8px;\n}\n\n.regionPanel {\n  margin-top: 0;\n  padding: 20px;\n  background: #f8fafc;\n  border: 1px solid #f3f4f6;\n  border-radius: 8px;\n}\n\n.regionHint {\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n  color: #999;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.regionHintIcon {\n  margin-right: 6px;\n  color: #69b1ff;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.regionGrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.regionCard {\n  position: relative;\n  padding: 12px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;\n\n  &:hover {\n    border-color: #91caff;\n\n    .regionEditBtn {\n      opacity: 1;\n    }\n  }\n}\n\n.regionCardActive {\n  background: #e6f4ff;\n  border-color: #1677ff;\n  box-shadow: 0 1px 4px rgba(22, 119, 255, 0.12);\n\n  .regionCardTitle {\n    color: #1677ff;\n  }\n}\n\n.regionCardHead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.regionCardTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n.regionCardDescRow {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n}\n\n.regionCardDesc {\n  flex: 1;\n  min-width: 0;\n  font-size: 11px;\n  color: #999;\n  line-height: 1.5;\n  word-break: break-word;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.regionCardDescActive {\n  color: #1677ff;\n}\n\n.regionCardInfoIcon {\n  flex-shrink: 0;\n  color: #69b1ff;\n  font-size: 12px;\n  cursor: default;\n}\n\n.regionEditBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  background: #f5f5f5;\n  color: #666;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.2s, border-color 0.2s, color 0.2s, background 0.2s;\n\n  :global(.anticon) {\n    font-size: 11px;\n  }\n\n  &:hover {\n    border-color: #91caff;\n    background: #e6f4ff;\n    color: #1677ff;\n  }\n}\n\n.regionEditBtnActive {\n  opacity: 1;\n  background: #fff;\n  border-color: #91caff;\n  color: #1677ff;\n}\n\n.regionError {\n  margin-top: 12px;\n  color: #ff4d4f;\n  font-size: 12px;\n}\n\n.regionGlobalHint {\n  margin-top: 8px;\n  color: #666;\n  font-size: 13px;\n}\n\n.countryGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px 16px;\n  max-height: 360px;\n  overflow-y: auto;\n}\n\n.regionSelectModal {\n  :global(.ant-modal-content) {\n    padding: 0;\n    overflow: hidden;\n    border-radius: 8px;\n  }\n\n  :global(.ant-modal-header) {\n    margin-bottom: 0;\n    padding: 16px 24px;\n    border-bottom: 1px solid #f3f4f6;\n  }\n\n  :global(.ant-modal-title) {\n    font-size: 15px;\n    font-weight: 600;\n    color: #333;\n  }\n\n  :global(.ant-modal-body) {\n    padding: 24px;\n  }\n\n  :global(.ant-modal-footer) {\n    margin-top: 0;\n    padding: 16px 24px;\n    background: #f9fafb;\n    border-top: 1px solid #f3f4f6;\n  }\n\n  :global(.ant-modal-close) {\n    top: 16px;\n    inset-inline-end: 20px;\n    color: #999;\n\n    &:hover {\n      color: #666;\n    }\n  }\n}\n\n.regionModalFooter {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.regionModalCountryGrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  width: 100%;\n}\n\n.regionModalCountryItem {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  margin: 0;\n  font-size: 13px;\n  color: #333;\n  cursor: pointer;\n\n  :global(.ant-checkbox-wrapper) {\n    align-items: center;\n    font-size: 13px;\n    color: #333;\n  }\n\n  &:hover :global(.ant-checkbox-wrapper) {\n    color: #1677ff;\n  }\n}\n\n.multiLangSection {\n  padding: 0;\n  overflow: hidden;\n}\n\n.multiLangCard {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.multiLangHead {\n  background: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.multiLangTitleRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.multiLangAccent {\n  width: 4px;\n  height: 16px;\n  border-radius: 999px;\n  background: #722ed1;\n  flex-shrink: 0;\n}\n\n.multiLangTitle {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #333;\n}\n\n.multiLangInfoIcon {\n  color: #999;\n  font-size: 16px;\n  cursor: help;\n\n  &:hover {\n    color: #1677ff;\n  }\n}\n\n.multiLangTabBar {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 4px;\n  padding: 8px 24px 0;\n  overflow-x: auto;\n}\n\n.multiLangTab {\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 6px;\n  padding: 10px 20px;\n  border: 1px solid transparent;\n  border-bottom: none;\n  border-radius: 8px 8px 0 0;\n  background: transparent;\n  color: #666;\n  font-size: 13px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: color 0.2s, background 0.2s, border-color 0.2s;\n\n  &:hover {\n    color: #333;\n  }\n}\n\n.multiLangTabActive {\n  position: relative;\n  z-index: 1;\n  margin-bottom: -1px;\n  border-color: #e5e7eb;\n  background: #fff;\n  color: #1677ff;\n  font-weight: 600;\n}\n\n.multiLangTabName {\n  line-height: 20px;\n}\n\n.multiLangTabBadges {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  align-items: flex-start;\n}\n\n.badgeDefault,\n.badgePending {\n  display: inline-flex;\n  align-items: center;\n  padding: 0 6px;\n  font-size: 10px;\n  line-height: 18px;\n  border-radius: 4px;\n}\n\n.badgeDefault {\n  color: #1677ff;\n  background: #e6f4ff;\n  border: 1px solid #91caff;\n}\n\n.badgePending {\n  color: #999;\n  background: #f5f5f5;\n}\n\n.badgePendingError {\n  color: #ff4d4f;\n  background: #fff2f0;\n  border: 1px solid #ffccc7;\n  font-weight: 600;\n}\n\n.multiLangTabPendingError {\n  color: #ff4d4f;\n\n  &:not(.multiLangTabActive) {\n    border-color: #ffccc7;\n    background: #fff2f0;\n  }\n\n  &.multiLangTabActive {\n    color: #ff4d4f;\n    border-color: #ffa39e;\n  }\n}\n\n.multiLangBody {\n  padding: 24px 32px 32px;\n}\n\n.multiLangContextAlert {\n  margin-bottom: 24px;\n  background: #e6f4ff;\n  border: none;\n\n  :global(.ant-alert-message) {\n    color: #1677ff;\n    font-size: 12px;\n  }\n}\n\n.multiLangPanel {\n  :global(.ant-form-item-label) {\n    min-width: 150px;\n  }\n}\n\n.multiLangPanelHidden {\n  display: none;\n}\n\n.defaultLangRow {\n  :global(.ant-form-item-control-input-content) {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    min-height: 32px;\n  }\n}\n\n.currentDefaultTag {\n  margin: 0;\n  font-size: 11px;\n  line-height: 18px;\n}\n\n.defaultLangHint {\n  color: #999;\n  font-size: 11px;\n}\n\n@media (max-width: 960px) {\n  .regionGrid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .regionGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .formItemLike {\n    flex-direction: column;\n  }\n\n  .formItemLabel {\n    width: auto;\n    text-align: left;\n    line-height: 1.5;\n    margin-bottom: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `idisfIAIQAIlOa90`,
	"sectionTitle": `yOFoI2kBO_U5FOCH`,
	"sectionDivider": `u4EH2J52ceYC2oVU`,
	"placeholder": `H4UBTpPtREk2EZ_h`,
	"footerBar": `f7JJ_gnm3yUA6rq8`,
	"infoAlert": `yepEWB1dKt4Ea75K`,
	"languageTags": `Qihw7CHxa1EvIPAu`,
	"langTagOption": `ZR2mSoEFMBAnpNiv`,
	"langTagSelected": `sHcZwDaa7yIer5VP`,
	"langTag": `r3OS4ocywUgl60fQ`,
	"formItemLike": `W5lM5NAhKI1GbRhA`,
	"formItemLabel": `uNexJ5UzBz4cdGtA`,
	"formItemControl": `KWXooUJKQcAbACpE`,
	"formControlOffset": `dkHgapqjssooT0yJ`,
	"requiredMark": `IMVtth1fGBgR_5w7`,
	"regionModeItem": `qRxU1zbG8IciBPLI`,
	"regionPanelItem": `RPku8vZc1FQfWuuS`,
	"regionPanel": `ZdDjhcibieQ38TRu`,
	"regionHint": `RYsjMD3yquQeQ6g6`,
	"regionHintIcon": `z6YCr5YSsfXlEVF7`,
	"regionGrid": `bZf3g6vKm8oe_x8r`,
	"regionCard": `Sz0BElC3hwDkHilv`,
	"regionEditBtn": `N4jC1g19AweKArSv`,
	"regionCardActive": `dbGfGDh9poaaZ_0i`,
	"regionCardTitle": `eCsmza2pGsQ2nd7M`,
	"regionCardHead": `m2ro4AfTZsUmhD9K`,
	"regionCardDescRow": `EqnBHD_WysngfuEp`,
	"regionCardDesc": `DAkmoe58XtEktWN_`,
	"regionCardDescActive": `JmeVWERrFZ46iVeI`,
	"regionCardInfoIcon": `MD1dA4Kel4eE_4YB`,
	"regionEditBtnActive": `iTDEI2rktfgdQM2c`,
	"regionError": `c5qJZOx4UDkzUHWG`,
	"regionGlobalHint": `Pkhb8M_Co8YLZu3g`,
	"countryGrid": `RY3jBUIfows25l5s`,
	"regionSelectModal": `WtcrdLcyRAQHlCXU`,
	"regionModalFooter": `hPUYRA2AdTI0PgxA`,
	"regionModalCountryGrid": `M_DM1NGbUk4ZzC9X`,
	"regionModalCountryItem": `HZC_1Ei9w8A3i0YA`,
	"multiLangSection": `C8GWlu84gH3DXYIr`,
	"multiLangCard": `z1eNzk7SNYzcwFfq`,
	"multiLangHead": `X7oa86RvxA5bAP6W`,
	"multiLangTitleRow": `c81w0JBvJMwLucOJ`,
	"multiLangAccent": `DjoEQTEhMKg6_8JQ`,
	"multiLangTitle": `j430bc7vcbMvTcD2`,
	"multiLangInfoIcon": `WKdP7i0Y5w0j_scK`,
	"multiLangTabBar": `SFOsdKtW0vow56CL`,
	"multiLangTab": `HuwrlCWgyeU0sRqd`,
	"multiLangTabActive": `sbtExcCLYhAxGiB7`,
	"multiLangTabName": `cpyBDSEowob_Db2I`,
	"multiLangTabBadges": `ylmUXV4g_ukEg_RM`,
	"badgeDefault": `iL3u70KIbakaVBn9`,
	"badgePending": `B3P_X16WNO8SyKww`,
	"badgePendingError": `zJD7uVXnOuUtLUe8`,
	"multiLangTabPendingError": `fsBKYdGuiqUqQ44C`,
	"multiLangBody": `wGTivW_5FXkG6PAe`,
	"multiLangContextAlert": `wDjEf51HIoQmnJKq`,
	"multiLangPanel": `Qugjoe4QRsrkx4g3`,
	"multiLangPanelHidden": `_1CLyf6dMDvaPrS5`,
	"defaultLangRow": `b79ABVX7K7cPTSY_`,
	"currentDefaultTag": `qQqWh2TH6Q0kVSXW`,
	"defaultLangHint": `ezPwQFmBbgs1mSKy`
};
export default ___CSS_LOADER_EXPORT___;
